import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { BlockUi, Box, CardContent, Grid, Paper, Typography } from '@availity/element';

import { AvailityHeaderLogo, Footer } from '@/components';
import { useAppContext } from '@/context';
import { useFRCallback } from '@/hooks';

// this page serves to consume an eprowtk query param and kick starts everything by feeding it into the journey for the EPRO account linking SSO.
// meanwhile on the UI, a standard 'loading' page is rendered.
const EProInit = ({ stepToRender, setCurrentStep }) => {
  const { queryParams = {} } = useAppContext();
  const { eprowtk } = queryParams;

  const { callbacks = [], textInputCallbackIndex } = useFRCallback(stepToRender);

  // pull the 'eprowtk' from query params and get the next journey node by passing it into the text input callback.
  useEffect(() => {
    if (eprowtk && textInputCallbackIndex >= 0) {
      const output = { ...stepToRender };
      const newCallbacks = [...callbacks];

      // add the 'eprowtk' value to the input of the text input callback.
      newCallbacks[textInputCallbackIndex].input = [
        {
          ...newCallbacks[textInputCallbackIndex].input[0],
          value: eprowtk,
        },
      ];

      // reconstruct the new step.
      Object.assign(output.payload.callbacks, [...newCallbacks]);

      // set the new step to push the journey along.
      setCurrentStep(output);
    }
  }, [eprowtk, textInputCallbackIndex]);

  return (
    <Grid
      id="epro-init-page-grid-container"
      container
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      spacing={0}
      sx={{ minHeight: '100vh', justifyContent: 'center' }}
    >
      <Grid
        id="logout-page-content-grid"
        container
        display="flex"
        flexDirection="column"
        alignItems="center"
        flexGrow={1}
      >
        <AvailityHeaderLogo />
        <Grid direction="column" alignItems="center" justifyContent="center">
          <Paper variant="elevation" elevation={6} sx={{ width: { xs: '350px', sm: '500px' } }}>
            <CardContent>
              <BlockUi
                tag="div"
                message={
                  <Typography variant="subtitle1">
                    <Box sx={{ fontWeight: 'bold' }}>Loading...</Box>
                  </Typography>
                }
                blocking
              >
                <Box sx={{ minHeight: '130px' }} />
              </BlockUi>
            </CardContent>
          </Paper>
        </Grid>
      </Grid>
      <Footer />
    </Grid>
  );
};

EProInit.propTypes = {
  stepToRender: PropTypes.object.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
};

export default EProInit;
